var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"h4 my-5 text-center iv-headline"},[_vm._v(_vm._s(_vm.moduleSettings.headline))]),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }